import { formatSelect } from '../../utils/search/formatParams'
import { IInitParams } from '../types/search.types'
import { IEventCard } from 'constants/types/card.types'
import { IOptions, IObj } from '../../constants/types/common.types'
import { STATIC_URL } from '../data'
import { specialityTexts, FilterTypeName, Key, pageKeys } from './search-data'
import { BASE_URL } from '../url'

/* Для единообразия с другими фильтрами */
const Option = {
  all: 'Все курсы',
  personal: 'Мои курсы',
}

const CoursesOptionAliases = [
  {
    option: Option.all,
    alias: 'all',
  },
  {
    option: Option.personal,
    alias: 'personal',
  },
]

const unAuthCoursesOptions = [Option.all]
const authCoursesOptions = Object.values(Option)

const InitParams: IObj<IInitParams> = {
  [Option.all]: {
    [Key.TEXT]: '',
    [Key.SPECIALITIES]: [],
    [Key.POINTS]: [],
    [Key.LECTURS]: [],
    [Key.PAGE]: '1',
  },
  [Option.personal]: {
    [Key.TEXT]: '',
    [Key.SPECIALITIES]: [],
    [Key.POINTS]: [],
    [Key.LECTURS]: [],
    [Key.PAGE]: '1',
  },
}

const InitValues = {
  params: {
    [Option.all]: InitParams[Option.all],
    [Option.personal]: InitParams[Option.personal],
  },
  pages: {
    [Option.all]: { [pageKeys.TOTAL]: 0, [pageKeys.CURRENT]: 0 },
    [Option.personal]: { [pageKeys.TOTAL]: 0, [pageKeys.CURRENT]: 0 },
  },
  cards: {
    [Option.all]: [] as IEventCard[],
    [Option.personal]: [] as IEventCard[],
  },
  allCount: {
    [Option.all]: 0,
    [Option.personal]: 0,
  },
}

const generateConfig = (specialities: IOptions[], points: IOptions[]) => {
  const baseCongfig = {
    input: {
      placeholder: 'Поиск по названию...',
      key: Key.TEXT,
      sideIconPath: `${STATIC_URL}/filters/search-icon.svg`,
    },
    main: [
      {
        inputType: FilterTypeName.SELECT,
        themes: specialities,
        mobileSwitchBtnText: specialityTexts,
        title: 'Специальность',
        placeholder: 'Поиск по специальностям...',
        key: Key.SPECIALITIES,
        formatter: formatSelect,
      },
      {
        inputType: FilterTypeName.SELECT,
        themes: points,
        // mobileSwitchBtnText: specialityTexts,
        title: 'Количество баллов',
        // placeholder: 'Поиск по специальностям...',
        key: Key.POINTS,
        formatter: formatSelect,
        customStyles: {
          control: () => ({
            display: 'none',
          }),
        },
      },
    ],
  }

  return {
    [Option.all]: baseCongfig,
    [Option.personal]: baseCongfig,
  }
}

const CoursesSearchURL = {
  COURSES: `${BASE_URL.NMO_COURSE}?count=true&prerecording=true`,
  COURSES_SINGLE: BASE_URL.NMO_COURSE,
  SUBSCRIBED: `${BASE_URL.NMO_COURSE}/subscribeCourses`,
}

const pointsFilters = [
  { label: '18', value: 18, key: Key.POINTS },
  { label: '36', value: 36, key: Key.POINTS },
  { label: '144', value: 144, key: Key.POINTS },
]

export {
  InitValues,
  generateConfig,
  Key,
  authCoursesOptions,
  unAuthCoursesOptions,
  CoursesOptionAliases,
  InitParams,
  Option,
  CoursesSearchURL,
  pointsFilters,
}
